import styled from 'styled-components';
import { DESKTOP_MIN_BREAK } from '#/shared/constants';

export const PayListBody = styled.div`
  background-color: ${props => props.theme.contentBgWithCards};
  color: ${props => props.theme.contentText};
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: ${DESKTOP_MIN_BREAK};
  padding: 0 8px 5px 8px;
  overflow-y: auto;
`;

export default PayListBody;
